import { PromotionPrizeType } from '../../../api/fetchers/promotionsV2/types/promotions';
import { promotionsV2Actions } from '../../../store/slices/promotionsV2/slice';
import type { GameCommunicationMessageType } from '../types';
import { MessageName } from '../types';

import { BaseCoreGameCommunicationProcessor } from './BaseCoreGameCommunicationProcessor';

interface PrizeDropWinMessage extends GameCommunicationMessageType {
  amount: string;
  beforeInit: boolean;
  bet: string;
  delay: number;
  id: string;
  mul: string;
  promoId: string;
  prizeType: PromotionPrizeType;
  seq: number;
  table: string;
  textPrize: string;
  transId: string;
  userId: string;
  wiid: string;
}

export class CorePromotionsBCPGameCommunicationProcessor extends BaseCoreGameCommunicationProcessor {
  public messageName = MessageName.BonusCardPromoWin;

  public process(message: PrizeDropWinMessage): void {
    this.store.dispatch(promotionsV2Actions.setBCPSocketResponse(message));
  }
}
